import type { UnionTypeLibelle } from '../../../techniques'

export const NatureContratHorsTT = ['Cdd', 'CddIntertion', 'Cdi'] as const
export type NatureContratHorsTT = (typeof NatureContratHorsTT)[number]

export const NatureContratTTInterimaire = ['TravailTemporaireCdi', 'TravailTemporaire'] as const
export type NatureContratTTInterimaire = (typeof NatureContratTTInterimaire)[number]

export const NatureContratTTPermanent = ['Cdd', 'Cdi'] as const
export type NatureContratTTPermanent = (typeof NatureContratTTPermanent)[number]

export type NatureContrat = NatureContratHorsTT | NatureContratTTInterimaire | NatureContratTTPermanent

export const NatureContratLibelle: UnionTypeLibelle<NatureContrat> = {
  Cdd: 'Contrat à Durée Déterminée',
  CddIntertion: 'Contrat à Durée Déterminée insertion',
  Cdi: 'Contrat à Durée Indéterminée',
  TravailTemporaireCdi: 'Contrat à Durée Indéterminée Intérimaire',
  TravailTemporaire: 'Contrat Travail Temporaire',
} as const
